"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightMap = void 0;
var react_1 = require("react");
var theme_1 = require("../theme");
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    color: 'inherit',
};
exports.weightMap = {
    light: 300,
    regular: 400,
    bold: 500,
    'extra-bold': 800,
};
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    root: {
        '& a': {
            color: theme.colors.Hannibal['600'],
            textDecoration: 'none',
        },
        '&::selection': {
            backgroundColor: theme.colors.Hannibal['400'],
            color: theme.colors.Grey['0'],
        },
    },
    typography: function (props) { return (__assign({ fontFamily: 'inherit', align: props.align, fontSize: props.size, margin: "".concat(theme.margins[props.margin || 'none'], "px 0"), fontWeight: exports.weightMap[props.weight || 'regular'] }, (props.uppercase && {
        textTransform: 'uppercase',
    }))); },
    h0: function (props) { return ({
        fontSize: props.size || 54,
        lineHeight: '126%',
        fontWeight: exports.weightMap[props.weight || 'extra-bold'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
    }); },
    h1: function (props) { return ({
        fontSize: props.size || 38,
        lineHeight: '126%',
        fontWeight: exports.weightMap[props.weight || 'bold'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
    }); },
    h3: function (props) { return ({
        fontSize: props.size || 16,
        lineHeight: '137%',
        fontWeight: exports.weightMap[props.weight || 'bold'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
    }); },
    h4: function (props) { return ({
        fontSize: props.size || 14,
        lineHeight: '143%',
        fontWeight: exports.weightMap[props.weight || 'bold'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
    }); },
    h2: function (props) { return ({
        fontSize: props.size || 24,
        lineHeight: '125%',
        fontWeight: exports.weightMap[props.weight || 'bold'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
    }); },
    textExtraLarge: function (props) { return ({
        fontSize: props.size || 30,
        lineHeight: '127%',
    }); },
    textLarge: function (props) { return ({
        fontSize: props.size || 18,
        lineHeight: '144%',
    }); },
    textMedium: function (props) { return ({
        fontSize: props.size || 14,
        lineHeight: '143%',
    }); },
    textSmall: function (props) { return ({
        fontSize: props.size || 12,
        lineHeight: '150%',
    }); },
    textExtraSmall: function (props) { return ({
        fontSize: props.size || 10,
        lineHeight: '160%',
        letterSpacing: 0.2,
    }); },
}); });
var Typography = function (props) {
    var theme = (0, react_jss_1.useTheme)();
    var styles = useStyles(__assign(__assign({}, props), { theme: theme }));
    var variant = props.variant, component = props.component, color = props.color, style = props.style, children = props.children, className = props.className;
    var element = (0, react_1.useMemo)(function () {
        var elementType = component || 'span';
        switch (variant) {
            case 'h0':
            case 'h1':
                elementType = 'h1';
                break;
            case 'h2':
                elementType = 'h2';
                break;
            case 'h3':
                elementType = 'h3';
                break;
            case 'h4':
                elementType = 'h4';
                break;
        }
        return elementType;
    }, [component, variant]);
    var textColor = (0, react_1.useMemo)(function () {
        if (!color)
            return 'inherit';
        return (0, theme_1.getThemeColorFromAlias)(color, theme.colors);
    }, [color, theme.colors]);
    return (0, react_1.createElement)(element, __assign(__assign({}, props), { className: (0, classnames_1.default)(styles.typography, styles.root, styles[variant], className), style: __assign({ color: textColor }, style) }), children);
};
Typography.defaultProps = defaultProps;
exports.default = Typography;
//# sourceMappingURL=index.js.map